import { render } from "./PageAddOption.vue?vue&type=template&id=395c255b"
import script from "./PageAddOption.vue?vue&type=script&lang=js"
export * from "./PageAddOption.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.16.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__